



















































import { Action, Getter } from 'vuex-class';
import {
  Component, Model, Prop, PropSync, Vue, Watch,
} from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon.vue';

@Component({
  name: 'SignUp2Template',
  components: {
    SvgIcon,
  },
})
export default class SignUp2Template extends Vue {
}
